import { useSelector } from 'react-redux'
import { profileView } from './storage'
import { Profile, UserRole } from './types'

export function useProfile(): Profile | undefined {
  return useSelector(profileView)
}

export function useUserIsTeacher() {
  const profile = useProfile()
  return profile?.school?.role === UserRole.TEACHER
}

export function useUserIsStudent() {
  const userProfile = useProfile()
  return userProfile?.school?.role === UserRole.STUDENT
}
